import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { styled } from '@mui/system';
import MuiButton from '@mui/material/Button';
import MuiGrid from '@mui/material/Grid';
import Icon from '@cpg-its/ads.common.icon';
import LoadingCircle from '@cpg-its/ads.common.loading-circle';
import { blue, darkBlue, extraLightGrey, lightGrey, white } from '@cpg-its/ads.constants.colors';
const StyledButton = styled(MuiButton)({
    background: 'none',
    borderRadius: 3,
    color: 'white',
    fontSize: '.875rem',
    fontWeight: 400,
    letterSpacing: 'inherit',
    minWidth: '0',
    padding: '.625rem',
    textShadow: 'none',
    textTransform: 'none',
    transition: 'none',
    '&:hover': {
        background: 'none',
        border: 'none',
        boxShadow: '0px 4px 8px rgba(48, 48, 48, 0.3)',
        textShadow: 'none',
    },
    '.MuiButton-label': {
        whiteSpace: 'nowrap',
        width: 'auto',
    },
});
const IconWrapper = styled(MuiGrid)({
    position: 'relative',
    width: 'initial',
});
const OuterBorder = styled(MuiGrid)({
    border: `1px solid ${darkBlue}`,
    borderRadius: 3,
    position: 'absolute',
    height: 'calc(100% + 4px)',
    width: 'calc(100% + 4px)',
    visibility: 'hidden',
});
const buttonStyles = {
    primary: {
        color: `${white} !important`,
        backgroundColor: blue,
        boxShadow: '0px 1px 1px rgba(48, 48, 48, 0.3)',
        '&:hover, &:focus, &:active': {
            backgroundColor: darkBlue,
        },
        '&:focus .outer-border': {
            visibility: 'visible',
        },
    },
    secondary: {
        color: `${blue} !important`,
        backgroundColor: lightGrey,
        boxShadow: '0px 1px 1px rgba(48, 48, 48, 0.3)',
        '&:hover, &:focus, &:active': {
            backgroundColor: extraLightGrey,
        },
        '&:focus .outer-border': {
            visibility: 'visible',
        },
    },
    tertiary: {
        color: `${blue} !important`,
        backgroundColor: white,
        '&:hover, &:focus, &:active': {
            backgroundColor: white,
        },
        '&:focus .outer-border': {
            visibility: 'visible',
        },
    },
};
const getDynamicStyles = ({ bold, buttonStyle, backgroundColor, hoverColor, color, size, fullWidth, minWidth, noBoxShadow, lessPadding, noPadding, }) => {
    const fontSizeMap = {
        small: 12,
        medium: 14,
        large: 16,
        xlarge: 20,
    };
    const fontSize = fontSizeMap[size ?? 'medium'] ?? 'inherit';
    let padding;
    if (noPadding) {
        padding = '0 !important';
    }
    else if (lessPadding) {
        padding = '4px !important';
    }
    else {
        padding = '.625rem';
    }
    const baseStyles = {
        fontWeight: bold ? 500 : 400,
        backgroundColor,
        color,
        '&:hover': {
            backgroundColor: hoverColor,
            boxShadow: noBoxShadow ? 'none !important' : '0px 4px 8px rgba(48, 48, 48, 0.3)',
            color,
        },
        fontSize,
        width: fullWidth ? '100%' : 'auto',
        minWidth: minWidth ? 136 : 'auto',
        padding,
    };
    const buttonStyleOverrides = buttonStyle ? buttonStyles[buttonStyle] : {};
    return {
        ...baseStyles,
        ...buttonStyleOverrides,
    };
};
export const ButtonComponent = ({ backgroundColor = '', bold = false, buttonStyle = undefined, color = '', count = null, disabled = false, fullWidth = false, hoverColor = backgroundColor || '', icon = null, iconColor = '', lessPadding = false, loading = false, minWidth = false, noBoxShadow = false, noPadding = false, onClick = () => { }, rightIcon = false, size, testId = undefined, text = '', type = undefined, }) => {
    const dynamicStyles = getDynamicStyles({
        bold,
        buttonStyle,
        backgroundColor,
        hoverColor,
        color,
        size,
        fullWidth,
        minWidth,
        noBoxShadow,
        lessPadding,
        noPadding,
    });
    const buttonIcon = (() => {
        if (icon) {
            return (_jsx(IconWrapper, { sx: {
                    paddingLeft: rightIcon ? '.5rem' : 0,
                    paddingRight: rightIcon ? 0 : '.5rem',
                }, container: true, children: _jsx(Icon, { color: iconColor || color, count: count, icon: icon }) }));
        }
        return null;
    })();
    const renderButtonContent = (() => {
        if (!loading) {
            if (rightIcon) {
                return (_jsxs(_Fragment, { children: [text, buttonIcon] }));
            }
            return (_jsxs(_Fragment, { children: [buttonIcon, text] }));
        }
        return _jsx(LoadingCircle, { size: "small" });
    })();
    return (_jsxs(StyledButton, { sx: dynamicStyles, "data-testid": testId, disabled: loading || disabled, onClick: !disabled ? onClick : () => { }, type: type, disableRipple: true, children: [renderButtonContent, _jsx(OuterBorder, { className: "outer-border" })] }));
};
export default ButtonComponent;
//# sourceMappingURL=button.js.map